<template>
  <div class="accordion-badge">
    <div
      @click="toggleJson"
      :class="{
        'api_response--badge': true,
        confirm: actionState === 'confirm',
        updated: actionState === 'updated',
      }"
      style="cursor: pointer"
    >
      {{ actionState === "confirm" ? "Action" : "Updated" }}
      <svg
        v-if="showJson"
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
        <g
          id="SVGRepo_tracerCarrier"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></g>
        <g id="SVGRepo_iconCarrier">
          <rect width="24" height="24" fill="transparent"></rect>
          <path
            d="M7 14.5L12 9.5L17 14.5"
            stroke="white"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
        </g>
      </svg>

      <svg
        v-else
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
        <g
          id="SVGRepo_tracerCarrier"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></g>
        <g id="SVGRepo_iconCarrier">
          <rect width="24" height="24" fill="transparent"></rect>
          <path
            d="M17 9.5L12 14.5L7 9.5"
            stroke="white"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
        </g>
      </svg>
    </div>
    <div
      @click="updateAPI"
      v-if="actionState === 'confirm'"
      class="api_response--action"
      style="cursor: pointer; margin-left: 10px; width: 112px; height: 25px"
    >
      <LoadingUI v-if="actionLoading" />
      <span v-else> Click to Update </span>
    </div>
    <transition name="fade">
      <div
        v-if="showJson"
        :class="{
          'api_response--json': true,
          confirm: actionState === 'confirm',
          updated: actionState === 'updated',
        }"
      >
        <JSONRenderer
          :jsonData="
            actionState === 'confirm'
              ? {
                  section: section,
                  action: action,
                  ...args,
                }
              : actionState === 'updated'
              ? api_response.updated || {}
              : {}
          "
        />
      </div>
    </transition>
  </div>
</template>

<script>
import { DtGPTDetailsAPIService } from "../../../services/dt-gpt.service";
import JSONRenderer from "./json-renderer.vue";
import { LoadingUI } from "@plugins/loading/loading";

import { dtGPTActions } from "../../../store/app/dtgpt/actions";
import { dtGPTGetters } from "../../../store/app/dtgpt/getters";
import {
  mapActionObject,
  mapAppActionObject,
  mapAppGetterObject,
  mapGetterObject,
} from "../../../store/global";

import * as dtGPTTypes from "../../../store/app/dtgpt/types";

export default {
  components: {
    JSONRenderer,
    LoadingUI,
  },
  props: {
    message: {
      type: Object,
      required: true,
    },
    messageIndex: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      actionState: "confirm",
      actionLoading: false,
      showJson: false,
      api_response: null,
    };
  },
  computed: {
    ...mapAppGetterObject(dtGPTGetters),
    section() {
      return this.message?.content?.command?.metadata?.section || "";
    },
    action() {
      return this.message?.content?.command?.metadata?.action || "";
    },
    args() {
      return this.message?.content?.args || {};
    },
  },
  methods: {
    ...mapAppActionObject(dtGPTActions),
    toggleJson() {
      this.showJson = !this.showJson;
    },
    async updateAPI() {
      if (this.actionLoading) return;
      this.actionLoading = true;
      const section = this.message?.content?.command?.metadata?.section || "";
      const action = this.message?.content?.command?.metadata?.action || "";

      const apiResponse = await DtGPTDetailsAPIService.httpGet(
        this.message?.content.command.identifier_of_api_point,
        {
          section: section,
          action: action,
          ...(this.message?.content?.args || {}),
        }
      );
      this.api_response = apiResponse;
      // console.log({
      //   "accordion-badge.vue:153 this.api_response": this.api_response,
      // });

      const messages = this.chat.messages.map((m, i) => {
        return i == this.messageIndex ? {...m, updateApiResponse: apiResponse} : m;
      });
      this[dtGPTTypes.SET_CHAT_MESSAGES](messages);

      if (apiResponse.success === true) {
        this.actionState = "updated";

        if (this.message.content.command.metadata.onsuccess) {
          this.$emit("onsuccess", this.message);
        }
      } else {
        this.actionState = "error";
      }
      this.actionLoading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.accordion-badge {
  .api_response--badge {
    font-weight: bold;
    padding: 5px 10px;
    border-radius: 5px;
    color: white;
    display: inline-block;

    border-bottom-right-radius: 0px;
    border-bottom-left-radius: 0px;

    &.confirm {
      background-color: #ca5c5c;
    }
    &.updated {
      background-color: #4caf50;
    }
  }
  .api_response--action {
    font-weight: bold;
    padding: 2px 8px;
    border-radius: 5px;
    background-color: #4d5fe7;
    color: white;
    display: inline-block;
  }

  .api_response--json {
    margin-top: 0px;
    background-color: white;
    border: 2px solid;
    &.confirm {
      border-color: #ca5c5c;
    }
    &.updated {
      border-color: #4caf50;
    }
    padding: 10px;
    border-radius: 5px;
    border-top-left-radius: 0px;
    overflow-x: auto;

    font-size: 12px;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>